import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import ReactHowler from 'react-howler';

interface PlaySpinProps {
    handleButtonPlay: () => void;
    icon: IconDefinition | null;
    audioSource: string;
    isPlaying: boolean;
}

const PlaySpin: React.FC<PlaySpinProps> = ({ handleButtonPlay, icon, audioSource, isPlaying }) => {
    return (
        <>
            <motion.div
                className="w-[100px] h-[100px] 4xl:w-[140px] 4xl:h-[140px] relative"
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.8 }}
            >
                <motion.svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 100 100"
                    className="w-[100px] h-[100px] 4xl:w-[140px] 4xl:h-[140px]"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 8, ease: "linear", repeat: Infinity }}
                >
                    <defs>
                        <path
                            id="circle"
                            d="
                        M 50, 50
                        m -37, 0
                        a 37,37 0 1,1 74,0
                        a 37,37 0 1,1 -74,0"
                        />
                    </defs>
                    <text className="text-[17px] tracking-widest">
                        <textPath href="#circle">Click Me - Let&rsquo;s play -</textPath>
                    </text>
                </motion.svg>
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                    <button
                        onClick={handleButtonPlay}
                        className="h-[54px] w-[54px] 4xl:w-[62px] 4xl:h-[64px] text-2xl md:text-[1.75rem] flex justify-center items-center bg-smoke text-neutral-100 rounded-full"
                    >
                        <FontAwesomeIcon icon={icon || faPlay} className="" />
                    </button>
                </div>
            </motion.div>
            <ReactHowler src={audioSource} playing={isPlaying} />
        </>
    );
};

export default PlaySpin;
